import axios from 'axios'
import { auth } from '../lib/firebase'
import { API_BASE_URL } from '@config'

async function authHeaders() {
  const idToken = await auth.currentUser?.getIdToken()
  return { Authorization: `Bearer ${idToken}` }
}

export async function fetchOnlineUids() {
  const response = await axios.get(`${API_BASE_URL}/admin/online`, {
    headers: await authHeaders()
  })
  return response.data
}

export async function fetchUsers({ cursor, limit } = {}) {
  const response = await axios.get(`${API_BASE_URL}/admin/users`, {
    headers: await authHeaders(),
    params: { cursor, limit }
  })
  return response.data
}

export async function fetchActivity({ cursor, limit, uid, type } = {}) {
  const response = await axios.get(`${API_BASE_URL}/admin/activity`, {
    headers: await authHeaders(),
    params: { cursor, limit, uid, type }
  })
  return response.data
}

export async function banUser(uid, { reason, alsoBanIp } = {}) {
  const response = await axios.post(
    `${API_BASE_URL}/admin/users/${uid}/ban`,
    { reason, alsoBanIp },
    { headers: await authHeaders() }
  )
  return response.data
}

export async function kickUser(uid) {
  const response = await axios.post(
    `${API_BASE_URL}/admin/users/${uid}/kick`,
    {},
    { headers: await authHeaders() }
  )
  return response.data
}

export async function unbanUser(uid) {
  const response = await axios.post(
    `${API_BASE_URL}/admin/users/${uid}/unban`,
    {},
    { headers: await authHeaders() }
  )
  return response.data
}

export async function fetchBannedIps() {
  const response = await axios.get(`${API_BASE_URL}/admin/banned-ips`, {
    headers: await authHeaders()
  })
  return response.data
}

export async function banIp(ip, reason) {
  const response = await axios.post(
    `${API_BASE_URL}/admin/banned-ips`,
    { ip, reason },
    { headers: await authHeaders() }
  )
  return response.data
}

export async function unbanIp(ip) {
  const response = await axios.delete(`${API_BASE_URL}/admin/banned-ips/${encodeURIComponent(ip)}`, {
    headers: await authHeaders()
  })
  return response.data
}
